(function() {
if (customElements.get('product-card')) return;

class ProductCard extends HTMLElement {
  connectedCallback() {
    this.variants = JSON.parse(this.querySelector('[data-variants]')?.textContent || '[]');
    this.variantInput = this.querySelector('[data-variant-id]');
    this.colorDropdown = this.querySelector('.product-card__dropdown[data-color-dropdown]');

    this.querySelectorAll('.product-card__dropdown').forEach(dropdown => {
      const trigger = dropdown.querySelector('.product-card__dropdown-trigger');
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggleDropdown(dropdown);
      });

      dropdown.querySelectorAll('.product-card__dropdown-item').forEach(item => {
        item.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.selectItem(dropdown, item);
        });
      });
    });

    this._onDocClick = (e) => {
      if (!this.contains(e.target)) this.closeAllDropdowns();
    };
    document.addEventListener('click', this._onDocClick);

    this.slides = this.querySelectorAll('.product-card__image-slide');
    this.currentSlide = 0;

    // Once the shopper browses the gallery (arrows/swatches), stop the lifestyle
    // hover overlay from covering their chosen image until the cursor leaves.
    this.addEventListener('mouseleave', () => {
      this.classList.remove('product-card--gallery-active');
    });

    // Show the default variant's image so card image matches the selected dropdown
    if (this.variantInput) {
      const defaultVariant = this.variants.find(v => String(v.id) === this.variantInput.value);
      if (defaultVariant?.image_id) this.showImageById(defaultVariant.image_id);
    }

    this.querySelectorAll('.product-card__img-arrow').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.changeImage(btn.dataset.imgDir);
      });
    });

    const form = this.querySelector('form[action*="/cart/add"]');
    const addBtn = form?.querySelector('.product-card__add-to-cart');
    if (form && addBtn) {
      // Change to type="button" so Slidecart doesn't intercept the form submit
      addBtn.type = 'button';
      addBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.ajaxAddToCart(form, addBtn);
      });
    }

    // Color swatches — display + image-swap + variant-aware PDP link (Stage 4).
    // Display only: does NOT change the quick-add variant. Defensively isolated so a
    // swatch interaction never triggers the card link or a future card-tap / quick-add.
    this.swatches = Array.from(this.querySelectorAll('[data-swatch]'));
    this.productUrl = this.dataset.productUrl || '';
    this.productLinks = this.querySelectorAll('.product-card__image-slide a, .product-card__title a');
    this.swatches.forEach((sw) => {
      // <button> activates on Enter/Space via a click event, so this covers keyboard too
      sw.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.selectSwatch(sw);
      });
    });
  }

  ajaxAddToCart(form, btn) {
    if (btn.disabled) return;

    const origText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(r => r.json())
      .then(data => {
        btn.textContent = 'Added!';

        // Update header cart badge
        fetch('/cart.js').then(r => r.json()).then(cart => {
          let badge = document.querySelector('.header__cart-count');
          if (!badge) {
            const cartLink = document.querySelector('a.header__icon[aria-label="Cart"]');
            if (cartLink) {
              badge = document.createElement('span');
              badge.className = 'header__cart-count';
              cartLink.prepend(badge);
            }
          }
          if (badge) badge.textContent = cart.item_count;
        });

        // Notify Slidecart — update first, then open after it refreshes
        if (typeof window.SLIDECART_UPDATE === 'function') window.SLIDECART_UPDATE();
        setTimeout(() => {
          if (typeof window.SLIDECART_OPEN === 'function') window.SLIDECART_OPEN();
        }, 300);

        setTimeout(() => {
          btn.textContent = origText;
          btn.disabled = false;
        }, 1500);
      })
      .catch(() => {
        btn.textContent = origText;
        btn.disabled = false;
      });
  }

  disconnectedCallback() {
    document.removeEventListener('click', this._onDocClick);
  }

  toggleDropdown(dropdown) {
    const isOpen = dropdown.classList.contains('product-card__dropdown--open');
    this.closeAllDropdowns();
    if (!isOpen) dropdown.classList.add('product-card__dropdown--open');
  }

  closeAllDropdowns() {
    this.querySelectorAll('.product-card__dropdown--open').forEach(d => {
      d.classList.remove('product-card__dropdown--open');
    });
  }

  selectItem(dropdown, item) {
    dropdown.querySelectorAll('.product-card__dropdown-item--selected').forEach(el => {
      el.classList.remove('product-card__dropdown-item--selected');
    });
    item.classList.add('product-card__dropdown-item--selected');
    dropdown.querySelector('.product-card__dropdown-trigger span').textContent = item.dataset.value;
    dropdown.classList.remove('product-card__dropdown--open');
    this.updateVariant();
    // Reverse sync: a color change in the dropdown moves the swatch ring too. No loop —
    // setSwatchSelected only toggles classes; it does not re-enter selectItem/selectSwatch.
    if (dropdown === this.colorDropdown) {
      this.setSwatchSelected(item.dataset.value);
    }
  }

  updateVariant() {
    const dropdowns = this.querySelectorAll('.product-card__dropdown');
    const selected = Array.from(dropdowns).map(d => {
      const item = d.querySelector('.product-card__dropdown-item--selected');
      return item ? item.dataset.value : '';
    });
    const match = this.variants.find(v =>
      v.options.every((opt, i) => opt === selected[i])
    );
    const btn = this.querySelector('.product-card__add-to-cart');

    // No such variant — this color+size combo was never produced. Make it impossible to add:
    // clear the id and disable the button (ajaxAddToCart bails on a disabled button).
    if (!match) {
      if (this.variantInput) this.variantInput.value = '';
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Unavailable';
      }
      return;
    }

    if (this.variantInput) {
      this.variantInput.value = match.id;
    }
    if (btn) {
      btn.disabled = !match.available;
      btn.textContent = match.available ? (btn.dataset.label || 'Add to cart') : 'Sold out';
    }
    if (match.price != null) {
      const priceEl = this.querySelector('.product-card__current-price');
      if (priceEl) priceEl.textContent = this.formatMoney(match.price);
      const compareEl = this.querySelector('.product-card__compare-price');
      if (compareEl) {
        compareEl.style.display = match.compare_at_price > match.price ? '' : 'none';
        if (match.compare_at_price > match.price) {
          compareEl.textContent = this.formatMoney(match.compare_at_price);
        }
      }
    }
    if (match.image_id) {
      this.showImageById(match.image_id);
    }
    this.dispatchEvent(new CustomEvent('variant:change', {
      detail: { variantId: match.id, price: match.price },
      bubbles: true
    }));
  }

  formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  showImageById(imageId) {
    const target = Array.from(this.slides).findIndex(
      s => s.dataset.imageId === String(imageId)
    );
    if (target === -1 || target === this.currentSlide) return;
    this.slides[this.currentSlide].classList.remove('product-card__image-slide--active');
    this.currentSlide = target;
    this.slides[this.currentSlide].classList.add('product-card__image-slide--active');
  }

  changeImage(dir) {
    if (!this.slides.length) return;
    this.classList.add('product-card--gallery-active');
    this.slides[this.currentSlide].classList.remove('product-card__image-slide--active');
    if (dir === 'next') {
      this.currentSlide = (this.currentSlide + 1) % this.slides.length;
    } else {
      this.currentSlide = (this.currentSlide - 1 + this.slides.length) % this.slides.length;
    }
    this.slides[this.currentSlide].classList.add('product-card__image-slide--active');
  }

  selectSwatch(sw) {
    if (!this.swatches || !this.swatches.length) return;
    this.classList.add('product-card--gallery-active');
    const color = sw.dataset.color;

    // Exactly one selected at a time (the ring)
    this.setSwatchSelected(color);

    // Swap to this color's variant image if it has one; otherwise keep the current photo
    if (sw.dataset.imageId) this.showImageById(sw.dataset.imageId);

    // Make the card's PDP links land on this color's variant
    const variantId = sw.dataset.variantId;
    if (variantId && this.productUrl && this.productLinks && this.productLinks.length) {
      const sep = this.productUrl.indexOf('?') === -1 ? '?' : '&';
      const url = this.productUrl + sep + 'variant=' + variantId;
      this.productLinks.forEach((a) => a.setAttribute('href', url));
    }

    // Keep the quick-add color in agreement so price, sold-out state, and the ATC variant all
    // match the color shown. Only where the quick-add exists — desktop hover + fine pointer
    // (Stage 4 scope). On touch the quick-add never renders, so the touch path is unchanged.
    if (this.colorDropdown && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      this.setColorDropdown(color);
      this.updateVariant();
    }
  }

  // Move the swatch ring to a color (toggles classes only — safe to call from either control)
  setSwatchSelected(color) {
    if (!this.swatches) return;
    this.swatches.forEach((s) => {
      const on = s.dataset.color === color;
      s.classList.toggle('product-card__swatch--selected', on);
      s.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  // Select a color in the quick-add dropdown (no updateVariant — caller decides when to resolve)
  setColorDropdown(color) {
    if (!this.colorDropdown) return;
    let matched = false;
    this.colorDropdown.querySelectorAll('.product-card__dropdown-item').forEach((el) => {
      const on = el.dataset.value === color;
      el.classList.toggle('product-card__dropdown-item--selected', on);
      if (on) matched = true;
    });
    if (matched) {
      const span = this.colorDropdown.querySelector('.product-card__dropdown-trigger span');
      if (span) span.textContent = color;
    }
  }
}

customElements.define('product-card', ProductCard);
})();
